import { render, staticRenderFns } from "./DeliveryPlanning.vue?vue&type=template&id=0488064e&"
import script from "./DeliveryPlanning.vue?vue&type=script&lang=js&"
export * from "./DeliveryPlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports